// extracted by mini-css-extract-plugin
export var cardIcon = "_7k-5";
export var cardIconUnframed = "_7k-9";
export var checkboxCard = "_7k-0";
export var checkboxCardSelected = "_7k-4";
export var disabled = "_7k-2";
export var interactive = "_7k-1";
export var outerBorder = "_7k-3";
export var spacerMedium = "_7k-8";
export var spacerSmall = "_7k-7";
export var spacerXsmall = "_7k-6";